import { IOption } from '@bpba/form-components';
import useAxios from 'axios-hooks';
import { UrlsBack } from '../constants/urls';
import { Dispatch, useEffect } from 'react';
import { AxiosError } from 'axios';
import { BackendErrorContainer } from '../config/axiosMessageExtractor';
import { CBU_SAME_BANK_ENABLED } from '../constants/settings';

export const useCBU = (setRequestErrorMessage: Dispatch<AxiosError<BackendErrorContainer, any>>) => {
  const [{ data: dataCbus, loading: loadingCbus }, refechCbus] = useAxios<IOption[]>(UrlsBack.FixedTermCbus, { manual: true });
  const [{ loading: loadingAliasCheck }, refechAliasCheck] = useAxios<boolean[]>(UrlsBack.FixedTermCheckAlias, { manual: true });

  useEffect(() => {
    refechCbus().catch(onError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onError(reason: any) {
    setRequestErrorMessage(reason);
  }

  const aliasCheck = async (alias: string) => {
    return (
      CBU_SAME_BANK_ENABLED ||
      (await refechAliasCheck({
        url: `${UrlsBack.FixedTermCheckAlias}/${encodeURIComponent(alias)}`,
      }))
    );
  };

  const hasCbu: boolean = dataCbus != null && Array.isArray(dataCbus) && dataCbus.length > 0;

  return [dataCbus, loadingCbus, loadingAliasCheck, hasCbu, aliasCheck] as const;
};
